import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { InventarioService } from '../../../services/inventario/inventario.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-movimientos-adm',
  templateUrl: './movimientos-adm.component.html',
  styleUrls: ['./movimientos-adm.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class MovimientosAdmComponent implements OnInit {
  load: boolean = false;
  loadMenu: boolean = false;
  lsTiendas: Array<any> = [];
  lsTiendas2: Array<any> = [];
  tiendaSelectedMain: any = {};
  tiendaSelected: any = {};
  lsTipoMovimiento: Array<any> = [];
  tipoMovimientoSelected: number = 0;
  activeIndex: number | undefined;
  token: any = {};
  conceptoIng: String = "";
  btnShow: boolean = true;
  listProducts: Array<any> = [];
  arrayProducts: Array<any> = [{
    codigoProducto: '',
    cantidad: null,
    descripcion: '',
    idTiendaProducto: 0
  }];
  arrayProductsPrint: Array<any> = [];
  lsMovimientos: Array<any> = [];
  infoEmpresa: any;
  dateQuery: Date = new Date();
  totalMovimiento: number = 0;
  totalCantidades: number = 0;
  totalMovimientoIng: number = 0;
  totalCantidadesIng: number = 0;
  infoUser: any = {};
  msgMovimiento: Array<any> = [];
  ddLevel1: Array<any> = [];
  ddLevel2: Array<any> = [];
  ddLevel3: Array<any> = [];
  level1Selected: any = {};
  level2Selected: any = {};
  level3Selected: any = {};
  lsEstadosFisicos: Array<any> = [];

  @ViewChild('btnProcesar') btnProcesar: any;

  constructor(private inventario: InventarioService, private catalogo: CatalogoService, private message: MessageService, private producto: ProductoService) { }

  ngOnInit(): void {
    this.lsTiendas = JSON.parse(localStorage.getItem('tiendas') ?? "[]");
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]") as Object;
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");

    this.inventario.getTipoMovimiento(this.token.token).subscribe((response) => {
      this.lsTipoMovimiento = (response as Array<any>).map((row: any) => {
        return { id: row.idMovimientoTipo, label: row.nombreMovimientoTipo + " (" + row.operacion + ")" }
      });
    });

    if (!localStorage.getItem("listProducts"))
      this.catalogo.getProductosProveedor(this.token.token).subscribe((response) => {
        this.listProducts = response as Array<any>;
        localStorage.setItem("listProducts", JSON.stringify(this.listProducts))
      });
    else
      this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]");
    // obtener los estados fisicos y las posibles ubicaciones
    this.producto.getUbicaciones(this.token.token, this.infoEmpresa[0].idProveedor).subscribe((respLocalizaciones) => {
      let infoLocalizacion = respLocalizaciones as Array<any>;
      this.ddLevel1 = infoLocalizacion.filter((row: any) => { return row.nivel == 1 });
      this.ddLevel2 = infoLocalizacion.filter((row: any) => { return row.nivel == 2 });
      this.ddLevel3 = infoLocalizacion.filter((row: any) => { return row.nivel == 3 });
    });

    this.producto.getEstadoFisico(this.token.token, this.infoEmpresa[0].idProveedor).subscribe((respEstadosFisico) => {
      this.lsEstadosFisicos = respEstadosFisico as Array<any>;
    });

    // review history register
    if (!!localStorage.getItem('tmpInfoHistory')) {
      const dataTemp = JSON.parse(localStorage.getItem('tmpInfoHistory') ?? "")
      // value assignments
      this.tipoMovimientoSelected = dataTemp.tipoMovimientoSelected;
      this.tiendaSelectedMain = dataTemp.tiendaSelectedMain;
      this.conceptoIng = dataTemp.conceptoIng;
      this.level1Selected = dataTemp.level1Selected;
      this.level2Selected = dataTemp.level2Selected;
      this.level3Selected = dataTemp.level3Selected;
      this.activeIndex = 0;
    }



  }


  addProducts = (index: number, add?: boolean) => {

    let item = this.listProducts.filter(item => {
      return item.codBarras.toLowerCase() == this.arrayProducts[index].codigoProducto.toLowerCase() || item.referencia.toLowerCase() == this.arrayProducts[index].codigoProducto.toLowerCase()
    });

    if (item.length == 1) {
      // validar que el producto no este registrado
      let row = this.arrayProducts.findIndex((data: any) => {
        return data.codigoProducto.toLowerCase() == this.arrayProducts[index].codigoProducto.toLowerCase()
      });
      if (row != index) {
        this.arrayProducts[index].error = "<div class='p-message p-message-warn'>El código relacionado ya existe en el listado</div>"
        return
      }
      this.arrayProducts[index].physicalCondition = this.lsEstadosFisicos[0];
      this.arrayProducts[index].descripcion = "<div class='p-message p-message-success'>" + item[0].descripcionCorta + "</div>";
      this.arrayProducts[index].text = item[0].descripcionCorta
      this.arrayProducts[index].error = '';
      this.arrayProducts[index].idProducto = item[0].idProducto;
      this.arrayProducts[index].precioProducto = item[0].precioProducto.precioPromocion;
      this.arrayProducts[index].observacion = this.conceptoIng;

      if (add ?? true)
        this.arrayProducts.push({
          codigoProducto: '',
          cantidad: null,
          descripcion: '',
          idProducto: 0
        });
    }
    else {
      this.arrayProducts[index].error = "<div class='p-message p-message-warn'>No hay coincidencias con el código del producto</div>"
    }


  }

  sumProductsTotals = () => {

    this.totalMovimientoIng = this.arrayProducts.map((row: any) => { return ((row.precioProducto ?? 0) * (row.cantidad ?? 0)) }).reduce((partial: number, x: number) => partial + x, 0);
    this.totalCantidadesIng = this.arrayProducts.map((row: any) => { return ((row.cantidad ?? 0)) }).reduce((partial: number, x: number) => partial + x, 0);
  }

  printDiv(elem: string, title: string, index?: number) {
    // si viene algo hay auqe armar la impresion
    if (!!index) {
      title = this.tipoMovimientoSelected == 5 ? "Ingreso de mercancia" : 'Salida de mercancia';
      this.arrayProductsPrint = this.lsMovimientos.map((row: any) => {
        return {
          text: row.descripcion,
          error: '',
          idTiendaProducto: row.idTiendaProducto,
          precioProducto: row.valorInventario / row.cantidad,
          cantidad: row.cantidad,
          observacion: row.observacion
        }
      });
    }

    setTimeout(() => {
      const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();

      let mywindow: any = window.open('', 'PRINT', 'height=400,width=800');

      mywindow.document.write('<html><head><title>' + document.title + '</title>');
      mywindow.document.write('<style>.grid {display: flex; margin-right: -.5rem; margin-left: -.5rem;margin-top: -.5rem;} .col-6{ flex: 0 0 auto; padding: .5rem; width:50%} .hidden{display:none;} </style>');
      mywindow.document.write('</head><body style="font-family: \'Segoe UI\' !important; font-size: 22px !important;" >');
      mywindow.document.write('<h5>' + title.toUpperCase() + ' CORRESPONDIENTE AL DÍA ' + dateConvert + '</h5><div style="text-align:center; width:302px">');
      mywindow.document.write(document.getElementById(elem)!.innerHTML);
      mywindow.document.write('</div></body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();
    }, (!!index) ? 3000 : 0);
    return true;
  }


  deleteProduct = (index: number) => {
    if (this.arrayProducts.length > 1)
      this.arrayProducts.splice(index, 1)
  }

  procesar = () => {
    // hacer perder el foco
    this.btnProcesar.nativeElement.blur();
    //Disabled control
    this.btnProcesar.nativeElement.disabled = true;

    this.load = true;
    this.arrayProductsPrint = [];
    if ((this.conceptoIng != "") && (this.tiendaSelectedMain.idTienda > 0)) {
      let validacion = this.arrayProducts.filter((row: any) => {
        return row.error != '' || row.cantidad <= 0 || row.descripcion == ''
      });
      if (validacion.length > 0) {
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Hay campos que faltan completar, favor valide la información' });
        this.load = false;
        this.btnProcesar.nativeElement.disabled = false;
      }
      else {
        if (((this.tipoMovimientoSelected == 6) && (this.tiendaSelected.idTienda > 0)) || (this.tipoMovimientoSelected != 6)) {
          // obtener totales
          this.totalMovimiento = this.arrayProducts.map(row => { return row.cantidad * row.precioProducto }).reduce((a, b) => { return a + b }, 0);
          this.totalCantidades = this.arrayProducts.map(row => { return row.cantidad }).reduce((a, b) => { return a + b }, 0);
          // clear localStorage temp
          localStorage.removeItem('tmpInfoHistory');
          // informaciòn de registro de movimientos a realizar
          let lsArray = this.arrayProducts.map((row: any) => {
            return {
              idMovimientoTipo: this.tipoMovimientoSelected,
              idTiendaProducto: row.idProducto,
              descripcion: this.conceptoIng.toUpperCase(),
              referencia: "",
              valor: row.cantidad,
              idEmpleadoProveedor: this.infoUser.empleadoProveedors[0].idEmpleadoProveedor,
              isCantidad: true,
              detalleRastreoIdMovimientoTiendaOrigNavigations: !row.detalleRastreoIdMovimientoTiendaOrigNavigation ? null : JSON.parse("[" + JSON.stringify(row.detalleRastreoIdMovimientoTiendaOrigNavigation) + "]"),
              idUbicacionProducto1: this.level1Selected.idUbicacionProducto ?? null,
              idUbicacionProducto2: this.level2Selected.idUbicacionProducto ?? null,
              idUbicacionProducto3: this.level3Selected.idUbicacionProducto ?? null,
              idEstadoFisico: row.physicalCondition?.idEstadoFisico ?? null
            }
          });
          this.load = false;
          console.log(lsArray);
          this.inventario.setRegistroMovimiento(this.token.token, lsArray, this.tiendaSelectedMain.idTienda, true, this.tiendaSelected.hasOwnProperty('idTienda') ? this.tiendaSelected.idTienda : 0)
            .subscribe({
              next: (response) => {
                this.message.add({ severity: 'success', summary: 'Confirmación', detail: response.toString() });
                this.btnShow = false;
                this.load = false;
                this.arrayProductsPrint = this.arrayProducts;
                this.getRastreo();
              }, error: (error: HttpErrorResponse) => {
                this.message.add({ severity: 'error', summary: 'Error', detail: 'Se ha presentado un error al momento de registrar, favor intente nuevamente' });
                this.btnProcesar.nativeElement.disabled = false;
              }
            })
        } else {
          this.load = false;
          this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione la tienda' });
          this.btnProcesar.nativeElement.disabled = false;
        }
      }
    } else {
      this.load = false;
      this.message.add({ severity: 'error', summary: 'Error', detail: 'Relacione la tienda principal y el concepto del movimiento' });
      this.btnProcesar.nativeElement.disabled = false;
    }
  }


  reload = () => {
    // dejar un temporal para seguir registrando
    const dataTemp = {
      tipoMovimientoSelected: this.tipoMovimientoSelected,
      tiendaSelectedMain: this.tiendaSelectedMain,
      conceptoIng: this.conceptoIng.toUpperCase(),
      level1Selected: this.level1Selected,
      level2Selected: this.level2Selected,
      level3Selected: this.level3Selected
    }
    localStorage.setItem('tmpInfoHistory', JSON.stringify(dataTemp))
    window.location.reload();
  }

  getInfoMovimientos = () => {
    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();
    if ((this.tipoMovimientoSelected > 0) && (this.tiendaSelectedMain.idTienda > 0)) {
      this.load = true;
      this.inventario.getMovimientos(this.token.token, this.tiendaSelectedMain.idTienda, dateConvert, this.tipoMovimientoSelected).subscribe((response) => {
        this.load = false;

        this.lsMovimientos = (response as Array<any>).map((row) => {
          return {
            idRegistro: row.idMovimientoTienda,
            idTiendaProducto: row.idTiendaProductoNavigation.idTiendaProducto,
            fechaRegistro: row.fechaRegistro,
            codBarras: row.idTiendaProductoNavigation.idProductoNavigation.codBarras,
            descripcion: row.idTiendaProductoNavigation.idProductoNavigation.descripcionCorta,
            unidadPresentacion: row.idTiendaProductoNavigation.idProductoNavigation.unidadPresentacion,
            cantidad: row.valor,
            valorInventario: row.valor * this.listProducts.filter((item) => { return item.idProducto == row.idTiendaProductoNavigation.idProducto })[0].precioProducto.precioPromocion,
            inventarioDisponible: row.idTiendaProductoNavigation.cantidadEnMano + row.idTiendaProductoNavigation.cantidadMasiva,
            observacion: row.descripcion
          }
        });

        this.totalCantidades = this.lsMovimientos.map(row => { return row.cantidad }).reduce((a, b) => { return a + b }, 0);
        this.totalMovimiento = this.lsMovimientos.map(row => { return row.valorInventario }).reduce((a, b) => { return a + b }, 0);
        if (this.lsMovimientos.length == 0)
          this.message.add({ severity: 'warn', summary: 'Información', detail: 'No se presentan movimientos para este tipo de movimiento' });
      })
    }
    else {
      this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione el tipo de movimiento y tienda a consultar' });
    }
  }

  getRastreo = () => {
    // revisar si alguna tienda a enviado algo
    this.msgMovimiento = [];
    this.lsTiendas2 = this.lsTiendas.filter((row: any) => {
      return row.idTienda !== this.tiendaSelectedMain.idTienda
    })

    this.inventario.getRastreoMovimiento(this.token.token, this.tiendaSelectedMain.idTienda).subscribe((response) => {
      (response as Array<any>).map((row: any, index: number) => {
        this.msgMovimiento.push({
          type: 'warn',
          text: 'Información enviada por la tienda: <b>' + row.idTiendaOrigenNavigation.nombreTienda
            + '</b>',
          concepto: "Recepcion de mercancia de la " + row.idTiendaOrigenNavigation.nombreTienda,
          index: index,
          detalleRastreoIdMovimientoTiendaDestinoNavigation: {
            idDetalleRastreo: row.detalleRastreos
          }
        })
      });
    })
  }

  cargarInfo = (index: number) => {
    this.conceptoIng = this.msgMovimiento[index].concepto;
    this.arrayProducts = this.msgMovimiento[index].detalleRastreoIdMovimientoTiendaDestinoNavigation.idDetalleRastreo.map((row: any) => {
      return {
        codigoProducto: this.listProducts.filter((item: any) => { return item.idProducto == row.idMovimientoTiendaOrigNavigation.idTiendaProductoNavigation.idProducto })[0].codBarras,
        detalleRastreoIdMovimientoTiendaOrigNavigation: { idRastreo: row.idRastreo, idDetalleRastreo: row.idDetalleRastreo, idMovimientoTiendaOrig: row.idMovimientoTiendaOrig }
      }
    });

    this.arrayProducts.forEach((row: any, index: number) => {
      this.addProducts(index, false);
    });

    this.navegar('listProducts', false);
  }

  replaceName = (str: string, event?: any, index?: number) => {
    // Identify if there is an enter and send to quantity field
    if (event.key == 'Enter' && str != '') {
      const nameControl = '#txt' + index + ' span input';
      const control = document.querySelector(nameControl) as HTMLElement;
      control.focus();
    }
    return str.replace(/[']+/g, "-");
  }

  goToProdNext = (event: any, index: number) => {
    if (event.key == 'Enter') {
      document.getElementById('txtProducto' + (index + 1))?.focus();
      event.preventDefault();
    }
  }

  navegar = (enlace: string, mobile: boolean) => {
    const el: any = document.getElementById(enlace);
    window.scrollTo(0, el.offsetTop + (mobile ? el.offsetParent.offsetTop : 0));
  }
}
